export default __webpack_public_path__ + "static/3-36c5446b9dafb9a4db9a72f83883302b.jpeg";